import type { GameContext } from '../core/GameContext';

export class SpatialGridSystem {
  /** 重建空间索引，并顺带刷新活动史莱姆的最大半径。半径是动态的，把这次遍历复用给
   *  最大值统计，邻域查询就不需要额外扫描，也不需要写死查询半径。 */
  rebuild(context: GameContext): void {
    const { grid, slimes } = context;
    grid.clear();
    let maxRadius = 0;
    for (let id = 0; id < slimes.capacity; id += 1) {
      if (slimes.active[id] === 0 || slimes.isDying(id)) continue;
      grid.insert(id, slimes.x[id], slimes.y[id]);
      if (slimes.radius[id] > maxRadius) maxRadius = slimes.radius[id];
    }
    slimes.maxActiveRadius = maxRadius;
  }
}
